import React from "react"

const StepHeader = ({ activeStep, title, description }) => (
  <>
    {/* {!!activeStep && (
      <div className="progress mb-2">
        <div
          className="progress-bar bg-danger"
          role="progressbar"
          style={{
            width: `${
              activeStep === 1
                ? 20
                : activeStep === 2
                ? 40
                : activeStep === 3
                ? 60
                : activeStep === 4
                ? 80
                : activeStep === 5
                ? 100
                : 0 * 10
            }%`,
          }}
        ></div>
      </div>
    )} */}
    <h2 className="mb-3 display-5">{title}</h2>
    <p className="lead-2 mb-5">{description}</p>
  </>
)

export default StepHeader
